export default function TasksDashboard() {
  return <div style={{ padding: 20 }}>INFORMATII DESPRE TASKURILE MELE!</div>;
}
